import React from 'react';
// Retained only for this page's own legacy body/h1/li rules; the admin pages
// no longer depend on them and actively override or work around them
// elsewhere (AdminPage.css, FileDrop.css, DangerZone.css, and others).
import './Drivers.css';
import StorePage from '../Components/StorePage';
import { allApps, typesForAffiliate } from '../Components/appTypes';

/**
 * Home lists one card per affiliate rather than one per app, so an operator with
 * a driver, back seat and booking app appears once — with a colored dot for each
 * type they have.
 */
const Home = (comps) => {
    const seen = new Set();
    const apps = allApps(comps)
        .filter((app) => (seen.has(app.iAffiliateID) ? false : seen.add(app.iAffiliateID)))
        .map((app) => ({ ...app, typeKeys: typesForAffiliate(comps, app.iAffiliateID) }));

    return <StorePage apps={apps} title="Browse All Apps" comps={comps} />;
};

export default Home;
